import { can } from '@/@layouts/plugins/casl'

export default function (app) {
    app.config.globalProperties.$myCan = (permission='write', resource='users') => {
        switch (permission) {
            case 'write':
                return can('write', resource) || can('write-self', resource)
            case 'read':
                return can('read', resource) || can('read-self', resource)
            default:
                return can(permission, resource)
        }
    }
}
